export const normalizeInput = (input) => {
    let output = "(";
    input.replace(/^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function (match, g1, g2, g3) {
        if (g1.length) {
            output += g1;
            if (g1.length == 3) {
                output += ")";
                if (g2.length) {
                    output += " " + g2;
                    if (g2.length == 3) {
                        output += " - ";
                        if (g3.length) {
                            output += g3;
                        }
                    }
                }
            }
        }
    }
    );
    return output;
};

export const NotNormalizeInput = (input) => {
    let output = "";

    output = input.replace("(", "");    
    output = output.replace(")", "");  
    output = output.replace(" - ", "");   
    
    return output;
}

export const currencyFormatter = ({ currency, value}) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      minimumFractionDigits: 2,
      currency
    }) 
    return formatter.format(value)
}

export const dateFormatter = (value) => {
    const date = new Date(value);
    //debugger

    const month = (date.getMonth() < 9) ? `0${date.getMonth()+1}` : date.getMonth()+1;
    const day = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
}